

export class fields_error {     
      
    error_prodCatId: boolean = false;   
    error_prodDispName: boolean = false;  
    error_groupModelNo: boolean = false;  
    error_isnew: boolean = false;  
    error_videoUrl: boolean = false;  
    error_remark: boolean = false;  
    error_cad: boolean = false;   
    error_refImg: boolean = false;  
    error_featureList: boolean = false; //done
    error_prodCode: boolean = false;  
    error_modelNum: boolean = false;  
    error_finish: boolean = false;  
    error_size: boolean = false;  
    error_mrp: boolean = false;  
    error_dispImg: boolean = false;  
    error_stock: boolean = false;  
    error_status: boolean = false;
    
};


export interface ProductFeature {
    finish: string;
    sizeUnit: string;
    size: string;
    mrp: string;
    stock: string;
    dispImg: string;
    dispImgData: string;
    prodCode: string;
    modelNum: string;
    selectedSizes: any[]; 
    // UI purpose
    uuid?: string;
    prodId: any;
    isedited:any;
    status:any;
    feature_errors:fields_error;
    prodCodeOld:string;

}

